/**
 * AI search strings (OWA-1386). Since OWA-1872 the support messenger's Ask tab shows
 * them; its own layout copy lives in public/support-widget/ask-view.mjs.
 */
export default {
    d_fixtureNotice: 'Pilot: answers come from sample data, not your firm\'s records.',
    d_threadExpired: 'This conversation has expired. Your next question starts a new one.',
    d_refused: 'AI search could not answer this question. Try asking it another way.',
    d_truncated: 'The answer was too long. Try a narrower question.',
    d_toolLimit: 'AI search could not finish looking this up. Try a narrower question.',
    d_rejected: 'This question is too long.',
    d_protectedData: 'Remove the Protected Data (such as Social Security, card, account or health details) from your question and ask again.',
    d_unavailable: 'AI search is not available right now. Try again in a few minutes.',
    d_rateLimited: 'You have asked a lot of questions in the last minute. Wait a minute and ask again.',
    d_notInPilot: 'AI search is not available for your firm yet.',
};
